<ng-progress></ng-progress>
<router-outlet></router-outlet>
<!-- custom container for notifications -->
<notifier-container></notifier-container>